import { PrimaryButton, TertiaryButton } from 'gridosComponents/Buttons';
import DialogActions from '@mui/material/DialogActions';

const DialogFormActions = ({ onClose, cancelButtonLabel, actionButtonLabel, disabled }) => {
  return (
    <DialogActions>
      <TertiaryButton onClick={onClose}>{cancelButtonLabel}</TertiaryButton>
      <PrimaryButton disabled={disabled} type="submit">
        {actionButtonLabel}
      </PrimaryButton>
    </DialogActions>
  );
};

export default DialogFormActions;
